module.exports = __webpack_public_path__ + "img/level1_mining_tool_shadow-1.c2214b8a.png";